import { render, staticRenderFns } from "./Marketmanagelist.vue?vue&type=template&id=e90b086e&scoped=true&"
import script from "./Marketmanagelist.vue?vue&type=script&lang=js&"
export * from "./Marketmanagelist.vue?vue&type=script&lang=js&"
import style0 from "./Marketmanagelist.vue?vue&type=style&index=0&id=e90b086e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90b086e",
  null
  
)

export default component.exports